import {
  Component,
  ViewChild,
  ComponentFactoryResolver,
  AfterContentInit,
  ElementRef,
  OnInit,
  ChangeDetectorRef,
  ViewContainerRef
} from '@angular/core';
import { OnDestroy } from '@angular/core';
import { HelpFileDTO } from './help.dtos';
import { UIService } from '../../../ui.service';
import { PlycaDataService } from '../../../../services/plyca.service';
import { Configuration } from '../../../conf/app.constants';
import { FormConfig } from '../../forms/form.objects';
import { formPlycaComponent } from '../../forms/formPlyca.component';
import { TranslateService } from '@ngx-translate/core';
import { ServiceLocator } from '../../../ServiceLocator';
import { HelpService, HelpType } from '../../../components/common/help/help.service';
import { HeaderActionsService } from '../sub-header/header-actions.service';
import { WaitLoadingService } from '../waitLoading/wait-loading.service';
import { ConfirmationService } from 'primeng-lts/api';
import { saveAs } from 'file-saver';
import { BaseComponent } from '../baseComponent/base.component';
import { PlycaErrorHandler } from '../../../../http/PlycaErrorHandler';

import { finalize } from 'rxjs/operators';
import { getSimpleIdentifierFromString } from '../../../api/plyca-dtos';
import * as lodash from 'lodash';

@Component({
  selector: 'plyca-helpAdmin',
  templateUrl: 'helpAdmin.template.html'
})
export class HelpAdminComponent extends BaseComponent implements AfterContentInit, OnDestroy, OnInit {


  locale: string;

  files: Array<HelpFileDTO>;
  helpModelFiles: any = [];
  selectedHelpFile: HelpFileDTO;
  editing = false;

  @ViewChild('formContainer', { read: ViewContainerRef, static: true })
  formContainer: ViewContainerRef;
  form: formPlycaComponent;
  private confirmationService: ConfirmationService;
  drafFiles: any;
  viewDropZone = false;
  reloadUploadedCancel: boolean;

  private newFilesCount = 1;


  @ViewChild('fileImport') fileImport: ElementRef;

  constructor(
    public uiService: UIService,
    protected componentFactoryResolver: ComponentFactoryResolver,
    protected plycaService: PlycaDataService,
    public helpService: HelpService,
    protected configuration: Configuration,
    private headerActionsService: HeaderActionsService,
    private waitService: WaitLoadingService,
    private plycaErrorHandler: PlycaErrorHandler,
    private elem: ElementRef,
    private translate: TranslateService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.HELP));
    this.translate = ServiceLocator.injector.get(TranslateService);
    this.confirmationService = ServiceLocator.injector.get(ConfirmationService);

  }
  ngOnInit(): void {
    this.locale = this.translate.currentLang;
  }

  ngAfterContentInit(): void {
    this.headerActionsService.setTaskDescription(this.elem, 'GeneralHelp.title', 'fas fa-question', true);
    this.load();
  }

  loadActionsInit() {

    if (this.helpModelFiles) {
      this.headerActionsService.clearActions();

      this.viewDropZone = false;
      this.subscribe(this.headerActionsService.addAction(
        'General.edit',
        'fas fa-pencil-alt',
        'btn btn-secondary',
        true
      ), () => {
        this.editMode();
      });

      this.headerActionsService.addDivider();
      this.subscribe(this.headerActionsService.addAction(
        'General.back',
        'fas fa-chevron-left',
        'btn-outline-secondary',
        true
      ), () => {
        this.uiService.routeBack();
      });
    }
  }

  loadActionsEdit() {
    if (this.helpModelFiles != undefined) {

      this.headerActionsService.clearActions();

      this.subscribe(this.headerActionsService.addAction(
        'General.save',
        'fas fa-save',
        'btn-primary',
        true
      ), () => {
        this.saveHelpFile();
      });

      this.subscribe(this.headerActionsService.addAction(
        'General.cancel',
        'fas fa-times',
        'btn-secondary',
        true
      ), () => {
        this.cancelEditing();
      });

      this.headerActionsService.addDivider();
      this.subscribe(this.headerActionsService.addAction(
        'General.back',
        'fas fa-chevron-left',
        'btn-outline-secondary',
        true
      ), () => {
        this.uiService.routeBack();
      });
    }
  }



  download(element: any) {

    let file = this.files.find(f => element === f.identifier);
    if (file) {
      let downloadfile = lodash.cloneDeep(file);
      downloadfile.helpElements.forEach(
        item => {
          let plist = [];
          if (item && item.profiles) {
            item.profiles.map((p: any) => {
              plist.push(getSimpleIdentifierFromString(p.identifier));
            })
            item.profiles = plist;
          }
        });
      let message = JSON.stringify(downloadfile,
        (k, v) => ((k === '_parent' || k === 'links' || k === 'rowUuid') ? undefined : v)
      );


      let data = new Blob([message], { type: 'text/plain;charset=utf-8' });
      saveAs(data, file.identifier + '.json', true);
    }

  }

  loadEnd() {

    if (this.editing) {
      this.loadActionsEdit();
    } else {
      this.loadActionsInit();
    }
    this.waitService.cancelWaiting();
  }

  load() {
    let message = this.translate.instant('Help.messages.loadFiles');
    this.waitService.startWaiting(message);
    this.subscribe(this.plycaService
      .query<any>(this.configuration.HELPFILES_SERVICE_URL)
      , resp => {
        if (resp && resp.content) {
          this.files = resp.content;
          this.dto2Model();
          // setTimeout(() => {
          //   this.selectFile(this.files[0].identifier);
          // }, 50);
          this.selectFile(this.files[0].identifier);
        } else {
          this.files = [];
          this.loadEnd();
        }
      }, () => {
        this.loadEnd();
      });
  }

  selectFile(fileId: string) {
    // if (!this.formContainer) {
    //   return;
    // }

    if (fileId) {

      this.waitService.startWaiting();

      this.selectedHelpFile = this.files.find(f => fileId === f.identifier);

      let _locales = [];
      this.translate.langs.forEach(el => _locales.push(this.elementLocaleModel(el)));
      this.selectedHelpFile.locales = _locales;

      this.toProfileDTO(this.selectedHelpFile);

      console.log('this.selectedHelpFile', this.selectedHelpFile);
      let _frmConfig = new FormConfig(undefined,
        'helpFileISettings.json',
        this.selectedHelpFile
      );

      _frmConfig.functions.push({
        identifier: 'isEditing',
        fn: this.isEditing.bind(this)
      });


      this.formContainer.clear();


      const childComponent = this.componentFactoryResolver.resolveComponentFactory(
        formPlycaComponent
      );
      // at this point we want the "child" component to be rendered into the app.component:
      this.form = this.formContainer.createComponent(childComponent).instance;
      this.form['formConfig'] = _frmConfig;
      this.subscribe(this.form.getCompleted(), loaded => {
        if (loaded) {
          this.loadEnd();
        }
      });

    } else {

      this.uiService.showMessage('no se ha conseguido seleccionar un fichero');
      this.waitService.startWaiting();

    }
  }

  private toProfileDTO(file: HelpFileDTO) {
    file.helpElements.forEach(
      item => {
        let list = [];
        if (item && item.profiles) {
          item.profiles.map((data: string) => {
            try {
              if (data['identifier']) {
                list.push(data);
              } else {
                let tmp = {};
                tmp['identifier'] = data + '<>PERFIL';
                list.push(tmp);
              }
            } catch (e) {
              console.log(e);
            }


          }

          );

          item.profiles = list;
        }




      });
  }

  dto2Model() {
    let _helpContent = [];
    this.files.forEach(f => {
      _helpContent.push(this.element2Model(f))
      this.toProfileDTO(f);
    }
    );
    this.helpModelFiles = _helpContent;
  }

  elementLocaleModel(element: string) {
    return {
      label: element,
      value: element
    };
  }

  element2Model(f: HelpFileDTO) {
    return {
      label: f.identifier,
      value: f.identifier
    };
  }
  newHelpFile() {
    // 1. SE ESTABLECE MODO EDICION
    // this.editing = true;
    this.editMode();

    // 2. SE CREA UNA REFERENCIA A UN NUEVO FICHERO DE AYUDA
    let el: HelpFileDTO = new HelpFileDTO();
    // marca temporal para saber si es un nuevo fichero
    el['NEW'] = true;
    el.identifier = '<Nuevo fichero ' + this.newFilesCount + '>';
    this.addFile(el);
    this.newFilesCount++;
    this.selectFile(el.identifier);
  }

  addFile(file: HelpFileDTO) {
    //    this.helpModelFiles.push(this.element2Model(file));
    this.files.push(file);
    this.dto2Model();
  }

  removeFile() {
    if (this.selectedHelpFile) {

      let message = this.translate.instant('Help.confirm.delete') + '</br><p class="col-12 text-center"><b>'
        + this.selectedHelpFile.identifier + '</b></p>';
      this.confirmationService.confirm({
        message: message,
        acceptLabel: this.translate.instant('General.yes'),
        rejectLabel: this.translate.instant('General.no'),
        accept: () => {

          this.subscribe(this.plycaService
            .delete<HelpFileDTO>(
              this.configuration.HELPFILES_SERVICE_URL,
              this.selectedHelpFile.identifier
            )
            , () => this.load());
        }
      });
    }
  }

  model2DTO(): any {
    let helpFile2Save = JSON.parse(
      JSON.stringify(this.selectedHelpFile, (k, v) =>
        (k === '_parent') ? undefined : v
      )
    );

    helpFile2Save.helpElements.forEach(


      element => {


        let list = [];
        if (element && element.profiles) {
          element.profiles.map((data) => {
            list.push(getSimpleIdentifierFromString(data.identifier));
          }

          )

          element.profiles = list;
        }

      });

    return helpFile2Save;
  }

  saveHelpFile() {
    this.reloadUploadedCancel = false;
    let helpFile2Save = this.model2DTO();
    let message = this.translate.instant('Help.messages.saving');
    this.waitService.startWaiting(message);
    if (helpFile2Save['NEW']) {
      this.subscribe(this.plycaService
        .insert<HelpFileDTO>(
          this.configuration.HELPFILES_SERVICE_URL,
          helpFile2Save
        ).pipe(finalize(() => {
          this.editing = false;
          this.loadActionsInit();
          // this.waitService.cancelWaiting();
          // lo cancela el load
        }))
        , () => {
          this.load()
        }, err => {
          this.showErrors(err);
        });
    } else {
      this.subscribe(this.plycaService
        .update<HelpFileDTO>(
          this.configuration.HELPFILES_SERVICE_URL,
          helpFile2Save
        ).pipe(finalize(() => {

          this.editing = false;
          this.loadActionsInit();

          //  this.waitService.cancelWaiting();
          // lo cancela en load
        }))
        , () => {
          this.load()
        }, err => {
          this.showErrors(err);
        });
    }

  }

  public editMode() {
    this.editing = true;
    this.form?.updateView();
    this.loadActionsEdit();

  }

  showErrors(err: any) {
    this.plycaErrorHandler.showServerError(err);
  }

  cancelEditing() {
    if (this.selectedHelpFile['NEW'] || this.reloadUploadedCancel) {
      this.load();
    }
    this.editing = false;
    this.form.updateView();
    this.loadActionsInit();
  }

  isEditing(): boolean {
    return this.editing;
  }


  ngOnDestroy() {
    this.uiService = null;

    // this.dialogService = null;
    // this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();

  }
  public openFileImportDialog(): void {
    this.fileImport.nativeElement.click();
  }


  onFileChange(evt: any) {

    // const target: DataTransfer = <DataTransfer>evt.target;
    if (evt.target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }

    let archivo = evt.target.files[0];
    if (!archivo) {
      return;
    }



    let lector = new FileReader();
    lector.onload = (e: any) => {


      // this.editMode();

      let el: HelpFileDTO = JSON.parse(e.target.result);
      let exist: HelpFileDTO = this.files.find(f => el.identifier === f.identifier);

      if (exist) {

        let message = this.translate.instant('Help.confirm.upload')
          + '</br><p class="col-12 text-center"><b>' + exist.identifier + '</b></p>';
        this.confirmationService.confirm({
          message: message,
          acceptLabel: this.translate.instant('General.yes'),
          rejectLabel: this.translate.instant('General.no'),
          accept: () => {

            this.files[this.files.findIndex(f => el.identifier === f.identifier)] = el;

            this.dto2Model();
            this.selectFile(el.identifier);
            this.editMode();
            this.reloadUploadedCancel = true;
          }
        });
      } else {
        el['NEW'] = true;
        this.addFile(el);
        this.newFilesCount++;
        this.selectFile(el.identifier);
        this.editMode();
      }


    };


    lector.readAsText(evt.target.files[0]);


    this.fileImport.nativeElement.value = null;

  }
}
